import React from 'react';
import SafeIcon from '../common/SafeIcon';

function resolveFileFormat(resource) {
  if (resource.fileFormat) return resource.fileFormat;
  const label = resource.format?.toLowerCase();
  if (label === 'pdf') return 'pdf';
  if (label === 'word') return 'docx';
  if (label === 'markdown') return 'md';
  return null;
}

function getFilePreviewStyle(fileFormat) {
  switch (fileFormat) {
    case 'pdf':
      return {
        surface: 'bg-brand-gold/12',
        iconWrap: 'bg-brand-gold/25',
        iconColor: 'text-brand-gold-dark',
        icon: 'FileText',
      };
    case 'docx':
      return {
        surface: 'bg-brand-cyan/10',
        iconWrap: 'bg-brand-cyan/20',
        iconColor: 'text-brand-cyan',
        icon: 'FileText',
      };
    case 'md':
      return {
        surface: 'bg-brand-green/10',
        iconWrap: 'bg-brand-green/20',
        iconColor: 'text-brand-green',
        icon: 'FileText',
      };
    default:
      return {
        surface: 'bg-[var(--bg-base)]',
        iconWrap: 'gfi-gradient-bg',
        iconColor: 'text-brand-navy',
        icon: 'FileText',
      };
  }
}

function getLinkPreviewStyle(resource) {
  if (resource.source === 'Canva') {
    return {
      surface: 'bg-[#00C4CC]/10',
      iconWrap: 'bg-[#00C4CC]/20',
      iconColor: 'text-[#00C4CC]',
      icon: 'Layout',
    };
  }
  if (resource.source?.includes('Google')) {
    return {
      surface: 'bg-[#4285F4]/10',
      iconWrap: 'bg-[#4285F4]/15',
      iconColor: 'text-[#4285F4]',
      icon: 'Grid',
    };
  }
  if (resource.source === 'Video') {
    return {
      surface: 'bg-brand-navy/10',
      iconWrap: 'bg-brand-navy/15',
      iconColor: 'text-brand-navy',
      icon: 'Video',
    };
  }
  return {
    surface: 'bg-brand-cyan/10',
    iconWrap: 'bg-brand-cyan/20',
    iconColor: 'text-brand-cyan',
    icon: 'ExternalLink',
  };
}

export default function ResourceCardPreview({ resource }) {
  const isFile = resource.type === 'file';
  const style = isFile
    ? getFilePreviewStyle(resolveFileFormat(resource))
    : getLinkPreviewStyle(resource);

  const formatLabel = isFile ? resource.format : resource.source;

  return (
    <div className={`relative aspect-[3/4] overflow-hidden ${style.surface} flex items-center justify-center`}>
      <div
        className={`w-20 h-20 md:w-24 md:h-24 rounded-3xl ${style.iconWrap} flex items-center justify-center shadow-lg transition-transform duration-300 group-hover:scale-105`}
      >
        <SafeIcon name={style.icon} className={`w-10 h-10 md:w-12 md:h-12 ${style.iconColor}`} />
      </div>
      {formatLabel && (
        <span className={`absolute bottom-5 text-[9px] font-black uppercase tracking-[0.25em] ${style.iconColor} opacity-80`}>
          {formatLabel}
        </span>
      )}
    </div>
  );
}
